<template>
  <v-dialog v-model="visible" max-width="460" persistent>
    <v-card id="aviso-existencias">
      <v-card-title class="text-h6">
        <v-icon color="orange darken-2" class="mr-2">mdi-alert</v-icon>
        Revisa en físico
      </v-card-title>
      <v-card-text>
        <p class="mb-2">Según el inventario de esta caja no alcanza para «{{ producto }}»:</p>
        <ul>
          <li v-for="(f, i) in faltantes" :key="i">
            <strong>{{ f.nombre }}</strong>: quedan {{ numero(f.quedan) }} y se necesitan
            {{ numero(f.necesita) }}<span v-if="f.unidad"> ({{ f.unidad }})</span>
          </li>
        </ul>
        <p class="mt-3 mb-0 caption">Si en físico sí hay, puedes venderlo igual.</p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text id="btn-cancelar-existencias" @click="responder(false)">Cancelar</v-btn>
        <v-btn color="primary" depressed id="btn-vender-igual" @click="responder(true)">Agregar de todas formas</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Aviso «según el inventario no alcanza» al elegir un producto (plugins/pos/existencias.js). No
 * bloquea: quien vende revisa en físico y decide.
 */
export default {
  name: 'AvisoExistencias',
  data: () => ({
    visible: false,
    producto: '',
    faltantes: [],
    resolver: null,
  }),
  methods: {
    /** @return {Promise<boolean>} true = agregar de todas formas */
    confirmar(producto, faltantes) {
      this.producto = producto;
      this.faltantes = faltantes;
      this.visible = true;
      return new Promise((resolve) => {
        this.resolver = resolve;
      });
    },
    responder(agregar) {
      this.visible = false;
      if (this.resolver) this.resolver(agregar);
      this.resolver = null;
    },
    numero(n) {
      return Number(n).toLocaleString('es-CO', { maximumFractionDigits: 2 });
    },
  },
};
</script>
